// extracted by mini-css-extract-plugin
export default {"login_wrapper":"Login_login_wrapper__EaWPa"};